import { Center, Spinner, Box } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import DeleteModal from './modals/DeleteModal';
import TableToolbar from './modals/TableToolbar';
import UpdateAndAddModal from './modals/UpdateAndAddModal';
import useProductKeywordsContainer from './ProductKeywordsContainer';
import { FC } from 'react';
import { IUserInfo } from 'types';

const ProductKeywordsViewer: FC<{ readonly: boolean; userInfo?: IUserInfo }> = ({ readonly, userInfo }) => {
    const props = useProductKeywordsContainer({ readonly, userInfo });

    const {
        tableInstance,
        isLoading,
        changingPage,
        sortableColumns,
        customFilters,
        paginationTableInstance,
        rowsPerPage,
        handleSort,
    } = props;

    return (
        <Box mt="16px">
            <TableToolbar {...props} />
            {isLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable
                        {...tableInstance}
                        isPagination
                        isHeaderFixed
                        manualSort={true}
                        sortableColumns={{ ...sortableColumns }}
                        handleSort={handleSort}
                        customFilters={customFilters}
                        isLoading={changingPage}
                    />
                    <TablePagination tableInstance={paginationTableInstance} pageSize={rowsPerPage} />
                </>
            )}
            <UpdateAndAddModal {...props} />
            <DeleteModal {...props} />
        </Box>
    );
};
export default ProductKeywordsViewer;
